import Modal from "../modal";
import { Select } from "../form-inputs/inputs";
import React from "react";

export const DigitalLiteSwitchModal = ({
    upc,
    setSwitchReason,
    openModal,
    switchDigitalToDigitalLite,
    reason,
    reasonOptions,
    isLoading,
    showSwitchModal,
}) => {
    return (
        <Modal show={showSwitchModal} onClose={() => openModal(false)}>
            <h2 className="txt-center">
                Are you sure you want to switch product <br />
                {upc} to a digital lite product? <br /> <br />
                This action cannot be undone.
            </h2>
            <div className="switch-container">
                <Select label="Reason" onChange={(event) => setSwitchReason(event.target.value)} value={reason} options={reasonOptions} />
                <div className="button-group -space-between">
                    <button className="button" onClick={() => openModal(false)}>
                        Cancel
                    </button>
                    <button disabled={isLoading || !reason} className="button -primary" onClick={switchDigitalToDigitalLite}>
                        Switch to digital lite
                    </button>
                </div>
            </div>
        </Modal>
    );
};
